<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>组织管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.name" placeholder="组织名称" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showAddDialog(null)">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="orgs" highlight-current-row v-loading="loading" border style="width: 100%;"
        row-key="id"

        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column type="index" width="60" fixed="left"></el-table-column>
        <el-table-column prop="name" label="机构名称" width="260" fixed="left" ></el-table-column>
        <el-table-column prop="level" label="机构等级" width="120" ></el-table-column>
        <el-table-column prop="type" label="机构类型" width="120" :formatter="formatType" ></el-table-column>
        <el-table-column prop="sort" label="排序" width="120" ></el-table-column>
        <el-table-column prop="detail.creditCode" label="统一社会信用代码" width="200" ></el-table-column>
        <el-table-column prop="detail.agencyCode" label="组织机构代码" width="160" ></el-table-column>
        <el-table-column prop="detail.contact" label="联系人姓名" width="120" ></el-table-column>
        <el-table-column prop="detail.mobile" label="联系人手机号" width="140" ></el-table-column>
        <el-table-column prop="detail.fixedPhone" label="固定电话" width="120" ></el-table-column>
        <el-table-column prop="detail.address" label="地址" width="260" ></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="180" ></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="180" ></el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.level<4" type="primary" size="mini" @click="showAddDialog(scope.row)">新增</el-button>
            <el-button type="primary" size="mini" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="delOrg(scope.$index,scope.row)">删除</el-button>
            <el-button v-if="scope.row.type!='00'" type="primary" size="mini" @click="showEvalDialog(scope.$index,scope.row)">点评</el-button>
            
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="机构名称" prop="name">
                <el-input v-model="editForm.name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="editForm.sort" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item label="统一社会信用代码" label-width="138px" prop="detail.creditCode">
                <el-input v-model="editForm.detail.creditCode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="组织机构代码" prop="detail.agencyCode">
                <el-input v-model="editForm.detail.agencyCode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人姓名" prop="detail.contact">
                <el-input v-model="editForm.detail.contact" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人手机号" prop="detail.mobile">
                <el-input v-model="editForm.detail.mobile" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="固定电话" prop="detail.fixedPhone">
                <el-input v-model="editForm.detail.fixedPhone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="机构地址" prop="detail.address">
                <el-input v-model="editForm.detail.address" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 
          <el-form-item label="权限">
            <el-tree
              :data="menus"
              show-checkbox
              node-key="id"
              :props="treeProps"
              ref="menuAddTree">
            </el-tree>
          </el-form-item>
           -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="130px" :rules="addFormRules" ref="addForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="单位名称" prop="name">
                <el-input v-model="addForm.name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="addForm.sort" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="detail.creditCode">
                <el-input v-model="addForm.detail.creditCode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="组织机构代码" prop="detail.agencyCode">
                <el-input v-model="addForm.detail.agencyCode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人姓名" prop="detail.contact">
                <el-input v-model="addForm.detail.contact" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人手机号" prop="detail.mobile">
                <el-input v-model="addForm.detail.mobile" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="固定电话" prop="detail.fixedPhone">
                <el-input v-model="addForm.detail.fixedPhone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="机构地址" prop="detail.address">
                <el-input v-model="addForm.detail.address" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit">提交</el-button>
        </div>
      </el-dialog>


      <!--评价-->
      <el-dialog title="评价" :visible.sync="evalFormVisible" :close-on-click-modal="false">
        <el-form :model="evalForm" label-width="130px" :rules="evalFormRules" ref="evalForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="评价等级" prop="eval_level">
                  <el-radio v-model="evalForm.eval_level" :label="1">&nbsp;</el-radio>
                  <div style="
                      width: 18px;
                      height: 18px;
                      border-radius: 10px;
                      margin-top: -28px;
                      margin-left: 20px;
                      background: #409EFF;
                      text-align: center;
                      color:#409EFF;
                      line-height:0;
                      font-size:10px;"/>
                  <el-radio v-model="evalForm.eval_level" :label="2">&nbsp;</el-radio>
                                    <div style="
                      width: 18px;
                      height: 18px;
                      border-radius: 10px;
                      margin-top: -28px;
                      margin-left: 20px;
                      background:  #E6A23C;
                      text-align: center;
                      color: #E6A23C;
                      line-height:0;
                      font-size:10px;"/>
                  <el-radio v-model="evalForm.eval_level" :label="3">&nbsp;</el-radio>
                                    <div style="
                      width: 18px;
                      height: 18px;
                      border-radius: 10px;
                      margin-top: -28px;
                      margin-left: 20px;
                      background: #F56C6C;
                      text-align: center;
                      color: #F56C6C;
                      line-height:0;
                      font-size:10px;"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remarks">
                <el-input v-model="evalForm.remarks" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="evalFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="evalSubmit">提交</el-button>
        </div>
      </el-dialog>



    </el-col>
  </el-row>
</template>
<script>
  import util from '../../common/util'
  import ORG_API from '../../api/api_org';

  export default {
    data() {
      return {
        filters: {
          name: ''
        },
        orgs: [],
        dictOrgType: [],
        loading: false,
        // selectRow: {}, //当前选择的行
        sels: [], //列表选中列
        // menus: [],
        // menuIds: [],//角色拥有的权限
        // treeProps: {
        //   children: 'children',
        //   label: 'text'
        // },

        //编辑相关数据
        editFormVisible: false,//编辑界面是否显示
        editFormRules: {
          name: [
            {required: true, message: '请输入机构名称', trigger: 'blur'}
          ],
          // code: [
          //   {required: true, message: '请输入机构编码', trigger: 'blur'}
          // ],
          // level: [
          //   {required: true, message: '请输入机构等级', trigger: 'blur'}
          // ],
          type: [
            {required: true, message: '请选择机构类型', trigger: 'blur'}
          ]
        },
        editForm: {
          detail: {}
        },


        //评价
        evalFormVisible: false,//评价
        evalFormRules: {},
        evalForm: {
          detail: {}
        },


        //新增相关数据
        addFormVisible: false,//新增界面是否显示
        addFormRules: {
          name: [
            {required: true, message: '请输入机构名称', trigger: 'blur'}
          ],
          // code: [
          //   {required: true, message: '请输入机构编码', trigger: 'blur'}
          // ],
          // level: [
          //   {required: true, message: '请输入机构等级', trigger: 'blur'}
          // ],
          type: [
            {required: true, message: '请选择机构类型', trigger: 'blur'}
          ]
        },
        addForm: {
          parentId: null,
          detail: {}
        }
      }
    },
    methods: {
      formatType: function (row, column) {
        var text = '未知';
        this.dictOrgType.forEach(function(item){
          if(item.value == row.type){
            text = item.name;
          }
        });
        return text;
      },
      handleSearch() {
        this.total = 0;
        this.page = 1;
        this.search();
      },
      search() {
        let that = this;
        let params = {
          name: that.filters.name
        };

        that.loading = true;
        ORG_API.findList(params).then(function (result) {
          that.loading = false;
          if (result && result.code == 200) {
            that.orgs = result.data.page;
            that.dictOrgType = result.data.dictOrgType;
          }
        }, function (err) {
          that.loading = false;
          that.$message.error({showClose: true, message: err.toString(), duration: 2000});
        }).catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
        });
      },
      //删除
      delOrg: function (index, row) {
        let that = this;
        this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
          that.loading = true;
          ORG_API.remove(row.id).then(function (result) {
            that.loading = false;
            if (result && parseInt(result.code) === 200) {
              that.$message.success({showClose: true, message: '删除成功', duration: 1500});
              that.search();
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({showClose: true, message: err.toString(), duration: 2000});
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
          });
        }).catch(() => {
        });
      },
      //显示编辑界面
      showEditDialog: function (index, row) {
        this.editFormVisible = true;
        //避免源对象row被修改
        var newRow = JSON.parse(JSON.stringify(row));
        this.editForm = Object.assign({}, newRow);
      },
      //编辑
      editSubmit: function () {
        let that = this;
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            let para = Object.assign({}, this.editForm);
            ORG_API.update(para).then(function (result) {
              that.loading = false;
              if (result && parseInt(result.code) === 200) {
                that.$message.success({showClose: true, message: '修改成功', duration: 2000});
                that.$refs['editForm'].resetFields();
                that.editFormVisible = false;
                that.search();
              } else {
                that.$message.error({showClose: true, message: '修改失败', duration: 2000});
              }
            }, function (err) {
              that.loading = false;
              that.$message.error({showClose: true, message: err.toString(), duration: 2000});
            }).catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
            });
          }
        });
      },


      //显示点评界面
      showEvalDialog: function (index, row) {
        this.evalFormVisible = true;
        //避免源对象row被修改
        var newRow = JSON.parse(JSON.stringify(row));
        this.evalForm = Object.assign({}, newRow);
      },
      //评价
      evalSubmit: function () {
        let that = this;
        console.log(that.evalForm);

            this.loading = true;

            let para = Object.assign({}, that.evalForm);
            ORG_API.update(para).then(function (result) {
              that.loading = false;
              if (result && parseInt(result.code) === 200) {
                that.$message.success({showClose: true, message: '评价成功', duration: 2000});
                that.$refs['evalForm'].resetFields();
                that.evalFormVisible = false;
                that.search();
              } else {
                that.$message.error({showClose: true, message: '评价失败', duration: 2000});
              }
            }, function (err) {
              that.loading = false;
              that.$message.error({showClose: true, message: err.toString(), duration: 2000});
            }).catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
            });
      },




      showAddDialog: function (row) {
        this.addFormVisible = true;
        this.addForm = {
          parentId: row? row.id: null,
          detail:{}
        };
      },
      //新增
      addSubmit: function () {
        let that = this;
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            that.loading = true;
            let para = Object.assign({}, this.addForm);
            ORG_API.add(para).then(function (result) {
              that.loading = false;
              if (result && parseInt(result.code) === 200) {
                that.$message.success({showClose: true, message: '新增成功', duration: 2000});
                that.$refs['addForm'].resetFields();
                that.addFormVisible = false;
                that.search();
              } else {
                that.$message.error({showClose: true, message: '修改失败', duration: 2000});
              }
            }, function (err) {
              that.loading = false;
              that.$message.error({showClose: true, message: err.toString(), duration: 2000});
            }).catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
            });

          }
        });
      },
      /* 
      handleCheckboxChange: function (row) {
        if(row.checked) {
          this.orgs.forEach(item => {
            if (item.id !== row.id) {
              item.checked = false
            }
          });
          this.selectRow = row;
          return;
        }
        this.selectRow = null;
        
      }
       */
    },
    mounted() {
      this.handleSearch()
    }
  }
</script>






// WEBPACK FOOTER //
// list.vue?4b134f1a